import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import Inicio from './pages/Inicio';
import SobreMi from './pages/SobreMi';
import Portfolio from './pages/Portfolio';
import Contacto from './pages/Contacto';

import Loader from './components/Loader';
import './styles/styles.css';

function App() {
  const [cargando, setCargando] = useState(true);
  const location = useLocation(); // ← para detectar cambios de ruta

  useEffect(() => {
    setCargando(true); // se activa el loader cada vez que cambia la ruta

    const startTime = Date.now();

    const handleLoad = () => {
      const elapsed = Date.now() - startTime;
      const minTime = 2000; // mínimo 2 segundos
      const remaining = Math.max(minTime - elapsed, 0);

      setTimeout(() => {
        setCargando(false);
      }, remaining);
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
      return () => window.removeEventListener('load', handleLoad);
    }
  }, [location.pathname]); // se ejecuta en cada ruta

  if (cargando) {
    return <Loader />;
  }

  return (
    <Routes>
      <Route path="/" element={<Inicio />} />
      <Route path="/sobre-mi" element={<SobreMi />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/contacto" element={<Contacto />} />
    </Routes>
  );
}

export default App;
